import { css } from '@emotion/react'
import { Theme } from '@emotion/react/dist/declarations/src'

const containerStyle = (t: Theme) => css`
  background: ${t.c.ec.white};
  display: flex;
  justify-content: center;
`

const spinnerStyle = (t: Theme) => css`
  width: 48px;
  height: 48px;
  margin: 12px;
  border: 2px solid ${t.c.bc.primary};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export const Spinner = () => {
  return (
    <div css={containerStyle}>
      <div css={spinnerStyle} />
    </div>
  )
}
